import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const clientSelectionSlice = createSlice({
    name: "enableClientSelection",
    initialState: { value: false },
    reducers: {
        updateClientSelection: (state, action: PayloadAction<boolean>) => {
            state.value = action.payload;
        },
    },
});

export const { updateClientSelection } = clientSelectionSlice.actions;

export default clientSelectionSlice.reducer;
